import vue from 'vue'
import axios from './axios'

const apiContent = {
  /*
   * 登录注册
   * */
  //  密码登录接口
  passLogin: (data) => {
    return axios('/home/User/login', data)
  },
  //  第一次登录修改密码
  setPass: (data) => {
    return axios('/home/User/setPass', data)
  },
  //  获取验证码
  sendMsg: (data) => {
    return axios('/home/User/send_phone_code', data)
  },
  //  找回密码
  resetPass: (data) => {
    return axios('/Home/User/forget_pass', data)
  },
  //
  allUser: (data) => {
    return axios('/welfare/index/login', data)
  },
  /*
   * 机构信息
   * */
  //  获取基本信息(包括基本信息 填写信息 组织风采)
  orgInfo: (data) => {
    return axios('/home/Mechanism/index', data)
  },
  //  填写部分基本信息提交
  mechanismSaveorupdate: (data) => {
    return axios('/home/Mechanism/mechanism_saveorupdate', data)
  },
  //  专题分类列表
  typeList: (data) => {
    return axios('/home/Mechanism/type_list', data)
  },
  //  删除组织风采
  closeOrganization: (data) => {
    return axios('/home/Mechanism/organization_del', data)
  },
  //  添加组织风采
  organizationAdd: (data) => {
    return axios('/home/Mechanism/organization_add', data)
  },
  //  修改组织风采
  organizationEdit: (data) => {
    return axios('/home/Mechanism/organization_edit', data)
  },
  //  提交网店
  shopTijiao: (data) => {
    return axios('/home/Mechanism/shop_tijiao', data)
  },
  /*
   * 帐号设置
   * */
  //  修改密码
  userSetPass: (data) => {
    return axios('/home/User/setPass', data)
  },
  //  修改手机号
  editPhone: (data) => {
    return axios('/home/User/edit_phone', data)
  },
  /*
   * 项目申报
   * */
  //  项目申报列表
  applyList: (data) => {
    return axios('/home/Project/apply_list', data)
  },
  //项目申报提交
  submitProject: (data) => {
    return axios('/home/Project/sub_apply', data)
  },
  //项目申报删除
  delProject: (data) => {
    return axios('/home/Project/del', data)
  },
  //项目申报第一步（首页）
  baseInfo: (data) => {
    return axios('/welfare/project/base_index', data)
  },
  // //项目申报第一步（添加）
  // baseAdd: (data) => {
  //   return axios('/home/Project/base_add', data)
  // },
  // //项目申报第一步（添加）
  // baseEdit: (data) => {
  //   return axios('/home/Project/base_edit', data)
  // },
  // //项目申报第二步（首页）
  // projectInfo: (data) => {
  //   return axios('home/Project/apply_index', data)
  // },
  // //项目申报第二步（添加）
  // projectAdd: (data) => {
  //   return axios('/home/Project/apply_add', data)
  // },


  // 修改后后的
  // 获取补充信息
  getBaseinfoSave: (data) => {
    return axios('/home/Project/baseinfo_save', data, 'get')
  },
  //  添加修改补充信息
  setBaseinfoSave: (data) => {
    return axios('/home/Project/baseinfo_save', data)
  },

  //  项目申报--新增项目
  applyAdd: (data) => {
    return axios('/home/Project/apply_add', data)
  },
  projectInfo: (data) => {
    return axios('/home/Project/apply_details', data, 'get')
  },


  //  获取荣誉列表
  getHonorList: (data) => {
    return axios('/home/Project/honor_list', data, 'get')
  },
  //  项目申报--新增/修改荣誉表彰
  addHonor: (data) => {
    return axios('/home/Project/add_honor', data)
  },
  //  删除荣誉
  honorDel: (data) => {
    return axios('/home/Project/honor_del', data)
  },
  //  项目申报--检测是否有已审核或审核过的项目
  isSubmit: (data) => {
    return axios('/home/Project/check_apply_audit', data)
  },
  //  提交补充信息
  supplement: (data) => {
    return axios('/home/Project/supplement_add', data)
  },


  // 上传图片
  file2: (data) => {
    return axios('/home/Uploadqiniu/conversion_file', data, 'post', false)
  },

  //  获取组织相关所有信息
  get_institution_info: (data) => {
    return axios('/home/Institutions/get_institution_info', data, 'get')
  },

  //  获取基本信息
  userInfo: (data) => {
    return axios('/home/info/user', data, 'get')
  },

  //  获取积分
  userIntegral: (data) => {
    return axios('/home/info/showIntegral', data, 'post')
  },
  //  留言列表
  userMessage: (data) => {
    return axios('/home/info/messageQuery', data, 'post')
  },
  //  留言
  submitMessage: (data) => {
    return axios('/api/Organization/addMessage', data, 'post')
  },
  //  增加积分
  addIntegral: (data) => {
    return axios('/home/info/addIntegral', data, 'post')
  },
  //  点赞
  dianzan: (data) => {
    return axios('/api/Organization/zanIntegral', data, 'post')
  },
  dianzan2: (data) => {
    return axios('/api/base/tongji2', data, 'post')
  },
  water: (data) => {
    return axios('/home/Images/water', data, 'post')
  },
  wenjian: (data) => {
    return axios('/home/Images/up', data, 'post')
  },
  applyState: (data) => {
    return axios('/home/Mechanism/setStatus', data, 'post')
  },




}
const api = {
  apiContent
}
vue.prototype.$api = api
